module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-10.webp?361ed57e";